import React from "react";
import { theme } from "../theme";
import { Icon } from "../icon";
export var FlagIcon = function () { return (React.createElement(Icon, { name: "flag", size: 16, color: theme.color.pink100 })); };
